const dayStrings = [
  `Sunday`,
  `Monday`,
  `Tuesday`,
  `Wednesday`,
  `Thursday`,
  `Friday`,
  `Saturday`,
];

export const parseWeather = (weatherXML) => {
  // Initialize return values with defaults
  let currentCondition = null;
  let currentTemperature = null;
  let currentWind = null;
  let currentHumidity = null;
  let forecastDaysData = [];

  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(weatherXML, `text/xml`);

    // Check for parser errors (basic check)
    if (xmlDoc.getElementsByTagName("parsererror").length > 0) {
      console.error("Error parsing weather XML");
      return {
        currentCondition,
        currentTemperature,
        currentWind,
        currentHumidity,
        forecastDays: forecastDaysData,
      };
    }

    const entries = Array.from(xmlDoc.getElementsByTagName(`entry`));
    if (!entries || entries.length === 0) {
      console.warn("No <entry> tags found in weather XML");
      return {
        currentCondition,
        currentTemperature,
        currentWind,
        currentHumidity,
        forecastDays: forecastDaysData,
      };
    }

    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    const currentConditionsEntry = entries.find(
      (entry) =>
        entry.textContent.includes(`Current Conditions`) ||
        entry.textContent.includes(weekday[new Date().getDay()])
    );

    if (currentConditionsEntry && currentConditionsEntry.textContent) {
      console.log(currentConditionsEntry.textContent);
      const inputString = currentConditionsEntry.textContent;

      // Use RegExp constructor for clarity and correct escaping
      const humidityRegex = new RegExp("(?<=<b>Humidity:</b>)(.*?)(?=<br/>)");
      const windRegex = new RegExp("(?<=<b>Wind:</b>)(.*?)(?=<br/>)");

      const humidityMatches = inputString.match(humidityRegex);
      const windMatches = inputString.match(windRegex);
      currentHumidity = humidityMatches ? humidityMatches[1].trim() : null; // Group 1 contains the captured text
      currentWind = windMatches ? windMatches[1].trim() : null; // Group 1 contains the captured text

      const currentConditionsSplit = currentConditionsEntry.textContent.split(`\n`);
      const currentConditionsLine = currentConditionsSplit.find(
        (item) =>
          item.includes(`Current`) || item.includes(weekday[new Date().getDay()])
      );
      console.log(currentConditionsSplit);

      if (currentConditionsLine) {
        // Use regex for more flexible parsing, handle potential missing parts
        // Need double backslashes for regex special chars inside string literals when using RegExp constructor
        const conditionRegex = new RegExp(":(.*?)(?:\\d|Forecast|\\.|,)", "i"); // Stop at digit, Forecast, period, OR comma
        const tempRegex = new RegExp("([\\d\\.]+)(?:\\s*°|&deg;)?C?", "i"); // Capture digits AND periods

        const conditionMatch = currentConditionsLine.match(conditionRegex);
        const tempMatch = currentConditionsLine.match(tempRegex);

        currentCondition = conditionMatch && conditionMatch[1] ? conditionMatch[1].trim().replace(/[,.]+$/, '') : null; // Trim whitespace AND trailing comma/period
        currentTemperature = tempMatch && tempMatch[1] ? tempMatch[1] + "°C" : null; // Add °C back if found

        // Fallback split if regex fails (less robust)
        if (!currentCondition && !currentTemperature) {
          const parts = currentConditionsLine.split(/: |, /).slice(1);
          currentCondition = parts[0] ? parts[0].trim().replace(/[,.]+$/, '') : null; // Trim whitespace AND trailing comma/period
          currentTemperature = parts[1] ? parts[1].trim() : null;
        }
      }
    } else {
      console.warn("Could not find 'Current Conditions' entry in weather XML");
    }

    //create an array of strings with the names of the next 3 days
    const todayNumeric = new Date().getDay();
    const forecastDaysNumeric = [
      //add 1, 2, 3 to the current day, and if it's past the end of the week subtract 7 to get the correct day
      todayNumeric + 1 <= 6 ? todayNumeric + 1 : todayNumeric + 1 - 7,
      todayNumeric + 2 <= 6 ? todayNumeric + 2 : todayNumeric + 2 - 7,
      todayNumeric + 3 <= 6 ? todayNumeric + 3 : todayNumeric + 3 - 7,
    ];

    const forecastDays = [
      dayStrings[forecastDaysNumeric[0]],
      dayStrings[forecastDaysNumeric[1]],
      dayStrings[forecastDaysNumeric[2]],
    ];

    // Use a safer loop
    forecastDays.forEach((day) => {
      const entry = entries.find(
        (e) => e.textContent && e.textContent.includes(day)
      );
      if (entry && entry.textContent) {
        const forecastLine = entry.textContent
          .split(`\n`)
          .find((item) => item.includes(day));

        if (forecastLine) {
          // Try parsing with more robust regex or split
          const parts = forecastLine.split(/: |\. /).slice(1);
          // Require at least condition and high temp (parts.length >= 2)
          if (parts.length >= 2) { 
            const dayObj = {
              name: day.substring(0, 3),
              condition: parts[0] ? parts[0].trim() : null,
              high: parts[1] ? parts[1].trim() : null,
              // Only add POP if it exists (parts.length >= 3)
              pop: parts.length >= 3 && parts[2] ? parts[2].trim() : null, 
            };
            forecastDaysData.push(dayObj);
          } else {
            console.warn(`Could not parse forecast line for ${day}: ${forecastLine}`);
          }
        } else {
          console.warn(`Could not find forecast line within entry for ${day}`);
        }
      } else {
        console.warn(`Could not find forecast entry for ${day}`);
      }
    });

    // If parsing successful, return the parsed data
    return {
      currentCondition,
      currentTemperature,
      currentWind,
      currentHumidity,
      forecastDays: forecastDaysData,
    };

  } catch (error) {
    console.error("Error processing weather XML:", error);
    // Return defaults only if an error occurred
    return {
      currentCondition: null,
      currentTemperature: null,
      currentWind: null,
      currentHumidity: null,
      forecastDays: [],
    };
  }
};

export const getConditionImageURL = (condition, suffix = ``) => {
  // Check if condition is null or undefined before processing
  if (!condition) {
    // Return a default 'unknown' image or null
    console.warn("getConditionImageURL received null condition");
    return `/img/weather/Cloud${suffix}.png`; // Or return null if preferred
  }
  //need to use global option to replace all spaces
  //the split is to cut off stuff like "high plus 3" if that's passed in
  condition = condition.toLowerCase().replace(/ /g, ``).split(".")[0];
  //console.log(condition);

  if ([`clear`, `sunny`, `mainlyclear`].includes(condition))
    return `/img/weather/Sunny${suffix}.png`;

  if (
    [`fog`, `shallowfog`, `mist`, `fogpatches`, `fogdissipating`].includes(
      condition
    )
  )
    return `/img/weather/Fog${suffix}.png`;
  if ([`mainlysunny`, `clearing`].includes(condition))
    return `/img/weather/PartSunny${suffix}.png`;

  if (
    [
      `afewclouds`,
      `amixofsunandcloud`,
      `partlycloudy`,
      `overcast`,
      `increasingcloudiness`,
    ].includes(condition)
  )
    return `/img/weather/SunWithCloud${suffix}.png`;

  if ([`cloudy`, `mostlycloudy`, `mainlycloudy`].includes(condition))
    return `/img/weather/Cloud${suffix}.png`;

  if (
    [
      `chanceofflurries`,
      `flurries`,
      `periodsofsnow`,
      `lightsnow`,
      `snow`,
      `heavysnow`,
      `snowgrains`,
      `afewflurries`,
      `driftingsnow`,
      `periodsoflightsnow`,
      `periodsofwetsnow`,
      `snowattimesheavy`,
      `flurriesattimesheavy`,
      `snowattimesheavyandblowingsnow`,
      `periodsofsnoworicepellets`,
      `periodsofsnowmixedwithicepellets`,
      `snowmixedwithicepellets`,
      `afewflurriesmixedwithicepellets`,
    ].includes(condition)
  )
    return `/img/weather/Snow${suffix}.png`;

  if (
    [
      `periodsofrainmixedwithsnow`,
      `periodsofsnowmixedwithrain`,
      `periodsofrainorsnow`,
      `periodsofsnoworrain`,
      `rainshowersorflurries`,
      `flurriesorrainshowers`,
      `chanceofflurriesorrainshowers`,
      `chanceofrainshowersorflurries`,
      `rainorsnow`,
      `snoworrain`,
      `snowattimesheavyorrain`,
      `afewflurriesorrainshowers`,
      `snowmixedwithrain`,
      `freezingrainattimesheavymixedwithicepellets`,
    ].includes(condition)
  )
    return `/img/weather/RainAndSnow${suffix}.png`;

  if (
    [
      `lightrain`,
      `rain`,
      `periodsofrain`,
      `chanceofshowers`,
      `showers`,
      `chanceoflightshowers`,
      `distantprecipitation`,
      `lightrainshower`,
      `periodsofrainordrizzle`,
      `afewshowers`,
      `lightdrizzle`,
      `chanceofshowersorthunderstorms`,
    ].includes(condition)
  )
    return `/img/weather/Rain${suffix}.png`;

  if ([`heavyrain`].includes(condition))
    return `/img/weather/HeavyRain${suffix}.png`;
  if ([`lightfreezingdrizzle`, `lightfreezingrain`].includes(condition))
    return `/img/weather/FeezingRain${suffix}.png`;
  if ([`lightning`].includes(condition))
    return `/img/weather/Lightning${suffix}.png`;
  if (
    [`thundershower`, `thunderstorms`, `chanceofthunderstorms`].includes(
      condition
    )
  )
    return `/img/weather/ThunderShower${suffix}.png`;

  return `/img/weather/Sunny${suffix}.png`;
};
